import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';

/**
 * One line of the review: an icon, what it is and what was entered. A value that
 * is `null` or empty reads "None" rather than leaving a blank, so the user sees
 * that nothing was provided instead of wondering whether it got lost.
 *
 * @param {object} props
 * @param {import('lucide-react').LucideIcon} props.icon
 * @param {string} props.label
 * @param {import('react').ReactNode} [props.children] The value. Omit it for "None".
 */
function ReviewRow({ icon: Icon, label, children }) {
  const { t } = useTranslation('unified-profiles');
  const hasValue = children !== null && children !== undefined && children !== '';

  return (
    <div className="flex items-center gap-3 rounded-lg border border-edge bg-surface px-3 py-2.5">
      <span className="flex size-8 shrink-0 items-center justify-center rounded-md bg-surface-muted text-content-secondary">
        <Icon className="size-4" aria-hidden />
      </span>
      <dt className="w-32 shrink-0 text-sm font-medium text-content">{label}</dt>
      <dd className="min-w-0 flex-1 text-sm text-content">
        {hasValue ? children : <span className="italic text-content-muted">{t('create.review.none')}</span>}
      </dd>
    </div>
  );
}

export default memo(ReviewRow);
